import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ImageModal = ({ imageUrl, title, onClose }) => {
  if (!imageUrl) return null;

  return (
    <>
      {/* gray out background */}
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        {/* modal outer container */}
        <div
          className="shadow-lg absolute flex flex-col px-3"
          style={{
            width: 500,
            maxWidth: "90%",
          }}
        >
          {/* modal inner container */}
          <div className="bg-white outline-none focus:outline-none overflow-hidden rounded-2xl my-12 relative">
            <div className="absolute top-0 right-0 m-6 z-10">
              <button
                className="z-50 h-8 w-8 bg-gray-100 hover:bg-gray-200 flex justify-center items-center rounded-md"
                onClick={onClose}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  size="lg"
                  className="text-gray-500"
                />
              </button>
            </div>
            <div className="p-4">
              {title && (
                <h3 className="text-lg font-semibold text-gray-900 mb-3 pr-8">
                  {title}
                </h3>
              )}
              <img
                src={imageUrl}
                alt={title || "Imagen del marcador"}
                className="w-full h-auto rounded-lg"
                style={{ maxHeight: "70vh", objectFit: "contain" }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="p-8 text-center text-gray-500">Error al cargar la imagen</div>';
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" onClick={onClose}></div>
    </>
  );
};

export default ImageModal;

